<template>
  <v-footer dark padless>
    <v-card flat tile class="grey darken-3 white--text text-center " width  = "100%">
      <v-card-text class="white--text pb-1">
        <div class="text-body-2">Av. General Mendiburu 686, Miraflores</div>
        <div class="text-body-2">Lun–Vie 8:00–19:00 · Sáb 9:00–16:00</div>
      </v-card-text>
      <v-card-text class="pt-1">
        <v-btn class="mx-4 white--text" href="https://www.instagram.com/hubdesignperu/" target="_blank" icon aria-label="Instagram de Hub Design">
          <v-icon size="24px">
            $instagram
          </v-icon>
        </v-btn>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text class="white--text">
        {{ new Date().getFullYear() }} — Hub Design
      </v-card-text>
    </v-card>
  </v-footer>
</template>
<script>
export default {
  name: "Footer",
};
</script>